import { useState } from "react";
import TemplateList from "./TemplateList";
import NotificationsQueue from "./NotificationsQueue";
import "../Notifications.scss";

/**
 * Outbox tab — the existing TemplateList rail + NotificationsQueue layout hosted
 * as the default sub-route of the Notifications page.
 * Behaviour and visual output are identical to the previous single-page layout.
 * @returns {import('react').JSX.Element}
 */
const Outbox = () => {
    const [templateListExpanded, setTemplateListExpanded] = useState(true);

    return (
        <div
            className="notifications-layout"
            data-template-collapsed={templateListExpanded ? undefined : true}
        >
            <TemplateList
                expanded={templateListExpanded}
                onExpandedChange={setTemplateListExpanded}
            />
            <NotificationsQueue />
        </div>
    );
};

export default Outbox;
